const forge = require("node-forge");

const V2_PREFIX = "enc:v2:";
const AES_KEY_BYTES = 32;
const AES_GCM_IV_BYTES = 12;
const AES_GCM_TAG_BITS = 128;
const AES_GCM_TAG_BYTES = AES_GCM_TAG_BITS / 8;

function parsePublicKey(pem) {
  return forge.pki.publicKeyFromPem(pem);
}

function base64UrlEncode(binary) {
  return forge.util
    .encode64(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

function packEncryptedPayload(wrappedKey, iv, tag, ciphertext) {
  const keyLength = wrappedKey.length;
  const keyLengthBytes = String.fromCharCode(
    (keyLength >> 8) & 255,
    keyLength & 255
  );

  return keyLengthBytes + wrappedKey + iv + tag + ciphertext;
}

function encryptPayloadWithPublicKey(text, publicKey) {
  if (!publicKey) {
    throw new Error("Payload encryption public key is not configured");
  }

  const value = text == null ? "" : text.toString();
  const aesKey = forge.random.getBytesSync(AES_KEY_BYTES);
  const iv = forge.random.getBytesSync(AES_GCM_IV_BYTES);
  const cipher = forge.cipher.createCipher("AES-GCM", aesKey);

  cipher.start({ iv, tagLength: AES_GCM_TAG_BITS });
  cipher.update(forge.util.createBuffer(value, "utf8"));

  if (!cipher.finish()) {
    throw new Error("Payload encryption failed");
  }

  const wrappedKey = publicKey.encrypt(aesKey, "RSA-OAEP", {
    md: forge.md.sha256.create(),
    mgf1: { md: forge.md.sha256.create() }
  });
  const tag = cipher.mode.tag.getBytes();

  if (tag.length !== AES_GCM_TAG_BYTES) {
    throw new Error("Invalid payload encryption tag");
  }

  const packedPayload = packEncryptedPayload(
    wrappedKey,
    iv,
    tag,
    cipher.output.getBytes()
  );

  return encodeURIComponent(`${V2_PREFIX}${base64UrlEncode(packedPayload)}`);
}

module.exports = {
  encryptPayloadWithPublicKey,
  parsePublicKey
};
